import { render, staticRenderFns } from "./materialScience_show.vue?vue&type=template&id=34305d22&scoped=true"
import script from "./materialScience_show.vue?vue&type=script&lang=js"
export * from "./materialScience_show.vue?vue&type=script&lang=js"
import style0 from "./materialScience_show.vue?vue&type=style&index=0&id=34305d22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34305d22",
  null
  
)

export default component.exports